module.exports = __webpack_public_path__ + "img/hakurei shrine.da656c17.png";